import * as React from "react";
import type { SVGProps } from "react";
const SvgBowlWithFood = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.205 9.01c1.01.104 1.802.962 1.597 1.977-.715 3.174-2.8 5.87-5.811 7.182A2 2 0 0 1 12 20H8a2 2 0 0 1-1.993-1.847C3.04 16.83 1.02 14.144.25 11.033.019 10.003.815 9.117 1.84 9.01zM2.302 11c.953 3.454 4.008 6 7.698 6 3.726 0 6.86-2.55 7.747-6z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m12.106 6.053 2.5-5 .05-.09a1 1 0 0 1 1.739.984l-2.501 5c-.626 1.12-2.367.263-1.788-.894"
    />
    <path
      fill="currentColor"
      d="M10.5 5.5c.838 0 1.786.138 2.59.262.863.133 1.508.238 1.91.238.74 0 1.361.488 1.755.913.499.54.872 1.21 1.071 1.918a1.69 1.69 0 0 1-.393 1.543A1.93 1.93 0 0 1 16 11H3.677c-2.73 0-2.005-3.777.006-4.448.514-.168 1.027-.364 1.558-.47C5.668 5.997 6.021 6 6.5 6c.385 0 .894-.099 1.634-.233C8.82 5.642 9.65 5.5 10.5 5.5m0 2c-.65 0-1.322.108-2.009.233C7.856 7.85 7.114 8 6.5 8c-.52 0-.668.003-.866.043-.449.09-.884.263-1.318.405-.29.097-.394.285-.443.552h11.89c-.131-.285-.3-.539-.476-.729-.096-.103-.208-.216-.34-.273-.595-.008-1.423-.146-2.162-.26-.822-.126-1.623-.238-2.285-.238"
    />
  </svg>
);
export default SvgBowlWithFood;
